import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute Component
 * Protects admin routes from unauthorized access
 */
const ProtectedRoute = ({ children }) => {
  // Check if admin is authenticated
  const adminAuth = localStorage.getItem('adminAuth');
  
  if (!adminAuth) {
    // Redirect to admin login if not authenticated
    return <Navigate to="/admin" replace />;
  }

  try {
    const authData = JSON.parse(adminAuth);
    
    // Check if session is still valid (optional: add expiration check)
    const loginTime = new Date(authData.loginTime);
    const now = new Date();
    const hoursSinceLogin = (now - loginTime) / (1000 * 60 * 60);
    
    // Session expires after 24 hours
    if (hoursSinceLogin > 24) {
      localStorage.removeItem('adminAuth');
      return <Navigate to="/admin" replace />;
    }
    
    // Check if user has admin role (super_admin, admin, or moderator)
    if (!['super_admin', 'admin', 'moderator'].includes(authData.role)) {
      return <Navigate to="/admin" replace />;
    }
    
    // User is authenticated and authorized
    return children;
  } catch (error) {
    // Invalid auth data
    localStorage.removeItem('adminAuth');
    return <Navigate to="/admin" replace />;
  }
};

export default ProtectedRoute;
